module.exports = __webpack_public_path__ + "img/img13.3b152239.png";